import Accordion from "react-bootstrap/Accordion";
import "./sidebar.css";
import images from "./images/images";
import { CORE_CONCEPTS } from "./sidear-data";

function Dropdownitems(props) {
  return (
    <Accordion.Item eventKey="0">
      <Accordion.Header>
        <div className="drop-head-1">{props.title}</div>
      </Accordion.Header>
      <Accordion.Body>
        <div className="d-flex">
          <div className="me-2">
            {" "}
            <img src={images.image4} alt="Image 4" />
          </div>
          <div className="drop-text-1">{props.desc1}</div>
        </div>

        <div className="d-flex mt-3">
          <div className="me-2">
            {" "}
            <img src={images.image4} alt="Image 4" />
          </div>
          <div className="drop-text-1">{props.desc2}</div>
        </div>

        <div className="d-flex mt-3">
          <div className="me-2">
            {" "}
            <img src={images.image4} alt="Image 4" />
          </div>
          <div className="drop-text-1">{props.desc3}</div>
        </div>

        <div className="d-flex mt-3">
          <div className="me-2">
            {" "}
            <img src={images.image4} alt="Image 4" />
          </div>
          <div className="drop-text-1">{props.desc4}</div>
        </div>

        <div className="d-flex mt-3">
          <div className="me-2">
            {" "}
            <img src={images.image4} alt="Image 4" />
          </div>
          <div className="drop-text-1">{props.desc5}</div>
        </div>

        <div className="d-flex mt-3">
          <div className="me-2">
            {" "}
            <img src={images.image4} alt="Image 4" />
          </div>
          <div className="drop-text-1">{props.desc6}</div>
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}

function Leftside() {
  return (
    <div>
      <div className="d-flex">
        <div className="leftsidebar">
          <div>
            {" "}
            <img src={images.image1} alt="Image 1" />
          </div>

          <div className="mt-2">
            {" "}
            <img src={images.image3} alt="Image 1" />
          </div>

          <div className="d-flex mod-1 mt-4">
            <div className="me-2">
              {" "}
              <img src={images.image2} alt="Image 2" />
            </div>
            <div className="mod-2">Dashboard</div>
          </div>

          <div className="mt-4">
            <Accordion defaultActiveKey="0">
              <Dropdownitems {...CORE_CONCEPTS[0]} />

              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="drop-head-1">Fleet</div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex">
                    <div className="me-2">
                      {" "}
                      <img src={images.image4} alt="Image 4" />
                    </div>
                    <div className="drop-text-1">Telematics</div>
                  </div>

                  <div className="d-flex mt-3">
                    <div className="me-2">
                      {" "}
                      <img src={images.image4} alt="Image 4" />
                    </div>
                    <div className="drop-text-1">Vehicles</div>
                  </div>

                  <div className="d-flex mt-3">
                    <div className="me-2">
                      {" "}
                      <img src={images.image4} alt="Image 4" />
                    </div>
                    <div className="drop-text-1">Maintenance</div>
                  </div>

                  <div className="d-flex mt-3">
                    <div className="me-2">
                      {" "}
                      <img src={images.image4} alt="Image 4" />
                    </div>
                    <div className="drop-text-1">Repair Orders</div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="drop-head-1">Contacts</div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex">
                    <div className="me-2">
                      {" "}
                      <img src={images.image4} alt="Image 4" />
                    </div>
                    <div className="drop-text-1">Customers</div>
                  </div>

                  <div className="d-flex mt-3">
                    <div className="me-2">
                      {" "}
                      <img src={images.image4} alt="Image 4" />
                    </div>
                    <div className="drop-text-1">Companies</div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="drop-head-1">Contacts</div>
                </Accordion.Header>
                <Accordion.Body></Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="drop-head-1">Forms</div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex">
                    <div className="me-2">
                      {" "}
                      <img src={images.image4} alt="Image 4" />
                    </div>
                    <div className="drop-text-1">Fines</div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="drop-head-1">Reports</div>
                </Accordion.Header>
                <Accordion.Body></Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
        <div className="rightsidebar">
          <div>Hello</div>
        </div>
      </div>
    </div>
  );
}

export default Leftside;
